export class DenonAvr {
    constructor(socket, log) {
        this.socket = socket;
        this.power = false;
        this.videoOutputs = Array(17).fill('1');
        this.masterMute = false;
        this.masterVolume = 50;
        this.maxVolume = 98;
        this.asyncHandlers = [
            {
                name: 'getVolumeMute',
                regExp: /MU\?/i,
                callback: (match) => {
                    this.socket.send(`MU${this.masterMute ? 'ON' : 'OFF'}`);
                },
            },
            {
                name: 'setVolumeMute',
                regExp: /MU(ON|OFF)/i,
                callback: (match) => {
                    this.masterMute = match[1].toLowerCase() === 'on';
                    this.socket.send(`MU${this.masterMute ? 'ON' : 'OFF'}`);
                },
            },
            {
                name: 'getVolume',
                regExp: /MV\?/i,
                callback: (match) => {
                    this.socket.send(`MV${this.masterVolume}`);
                },
            },
            {
                name: 'setVolume',
                regExp: /MV(\d+)/i,
                callback: (match) => {
                    this.masterVolume = parseInt(match[1], 10);
                    if (this.masterVolume <= this.maxVolume) {
                        this.socket.send(`MV${this.masterVolume.toString().padStart(2, '0')}`);
                    }
                    else {
                        this.masterVolume = this.maxVolume;
                    }
                    this.socket.send(`MVMAX ${this.maxVolume.toString().padStart(2, '0')}`);
                },
            },
            {
                name: 'getRoute',
                regExp: /SI\?/i,
                callback: (match) => {
                    this.socket.send(`SI${this.videoOutputs[0]}`);
                },
            },
            {
                name: 'powerSet',
                regExp: /(PWON|PWSTANDBY)/i,
                callback: (match) => {
                    this.power = match[1] === 'PWON';
                    this.socket.send(this.power ? 'PWON' : 'PWSTANDBY');
                },
            },
            {
                name: 'powerQuery',
                regExp: /PW\?/i,
                callback: (match) => {
                    this.socket.send(this.power ? 'PWON' : 'PWSTANDBY');
                },
            },
            {
                name: 'setRoute',
                regExp: /SI(.+)/i,
                callback: (match) => {
                    this.videoOutputs[0] = match[1];
                    this.socket.send(`SI${match[1]}`);
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`CMD Error!`);
                },
            },
        ];
    }
}
DenonAvr.emulatorType = 'socketEmulator';
DenonAvr.key = '-MX8p-KpucDrhrwWkkyQ';
